export const amountString = (num?: string, notComma?: boolean, digit?: number): string => {
  const replaceForm = /\B(?=(\d{3})+(?!\d))/g
  let top: string
  const digits = digit ? digit + 1 : 4

  if (num) {
    if (num.indexOf('.') !== -1) {
      if (notComma) {
        top = num.substring(0, num.indexOf('.'))
      } else {
        top = num.substring(0, num.indexOf('.')).replace(replaceForm, ',')
      }
      const bottom = Number(num.substring(num.indexOf('.'), num.indexOf('.') + digits))
        .toString()
        .slice(1)

      if (bottom.indexOf('e') > -1 || bottom.indexOf('E') > -1) {
        return top + num.substring(num.indexOf('.'), num.indexOf('.') + digits)
      } else {
        return `${top}${bottom}`
      }
    }
    if (notComma) {
      return num
    } else {
      return num.replace(replaceForm, ',')
    }
  }
  return '-'
}
